export const orderby = [
  {
    id: 0,
    name: "Più Venduti",
    key: "BEST-SELLERS",
  },
  {
    id: 1,
    name: "Consigliati",
    key: "RECOMMENDED"
  },
  {
    id: 2,
    name: "Ultimi arrivi",
    key: "LATEST-ARRIVALS",
  },
  {
    id: 3,
    name: "Scontati",
    key: "DISCOUNTED",
  },
  {
    id: 4,
    name: "Prezzo più basso",
    key: "LOWEST-PRICE",
  },
  {
    id: 5,
    name: "Prezzo più alto",
    key: "HIGHER-PRICE",
  },
];
